module.exports = __webpack_public_path__ + "static/media/404Text.d414d930.png";